export default "__VITE_ASSET__8d207e58__"